export default __webpack_public_path__ + "static/media/miod.d1688e37.svg";